export function showShimmer(container, message = 'Loading...') {
  if (!container) return;

  // Prevent duplicate shimmer blocks
  if (container.querySelector('.shimmer-placeholder')) return;

  const shimmer = document.createElement('div');
  shimmer.className = 'shimmer-placeholder';
  shimmer.textContent = message;
  shimmer.innerHTML = `
  <span class="shimmer-icon">🍴</span>
  <span>${message}</span>
`;
shimmer.setAttribute('data-mode', 'empty');

  container.appendChild(shimmer);
}

export function hideShimmer(container) {
  if (!container) return;

  const shimmer = container.querySelector('.shimmer-placeholder');
  if (shimmer) shimmer.remove();
}